export default __webpack_public_path__ + "static/media/journeytray-bluetree-flower.bf4dbb2a.svg";